import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

interface SectionHeaderProps {
  title: string;
  count?: number;
  /** One line under the title. */
  description?: ReactNode;
  actions?: ReactNode;
  id?: string;
  /** In the band's overlap zone, where the backdrop is still navy, not the white surface below it. */
  onBand?: boolean;
}

export function SectionHeader({ title, count, description, actions, id, onBand = false }: SectionHeaderProps) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-x-4 gap-y-3">
      <div className="min-w-0">
        <h2 id={id} className={cn('flex items-center gap-2 text-[22px]', onBand && 'text-band-fg')}>
          {title}
          {count !== undefined && (
            <span
              className={cn(
                'rounded-full px-2.5 py-0.5 font-sans text-[13px] font-semibold',
                onBand ? 'bg-band-raised text-band-accent' : 'bg-accent-wash text-accent',
              )}
            >
              {count}
            </span>
          )}
        </h2>
        {description && <p className={cn('mt-0.5 text-[13px]', onBand ? 'text-band-fg-secondary' : 'text-fg-muted')}>{description}</p>}
      </div>
      {actions}
    </div>
  );
}
